/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Completed_SuccessInputs */

const en_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save project completed successfully`)
};

const fr_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du projet terminé avec succès`)
};

const de_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt erfolgreich gespeichert`)
};

const it_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio del progetto completato con successo`)
};

const ru_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект успешно завершен.`)
};

const es_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar proyecto completado exitosamente`)
};

const zh_cn2_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目保存已成功完成`)
};

const ja_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの保存が正常に完了しました`)
};

const hi_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सफलतापूर्वक पूरा हो गया`)
};

const pt_pt2_save_completed_success = /** @type {(inputs: Save_Completed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto concluído com sucesso.`)
};

/**
* | output |
* | --- |
* | "Save project completed successfully" |
*
* @param {Save_Completed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_completed_success = /** @type {((inputs?: Save_Completed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Completed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_completed_success(inputs)
	if (locale === "de") return de_save_completed_success(inputs)
	if (locale === "it") return it_save_completed_success(inputs)
	if (locale === "ru") return ru_save_completed_success(inputs)
	if (locale === "es") return es_save_completed_success(inputs)
	if (locale === "zh-CN") return zh_cn2_save_completed_success(inputs)
	if (locale === "ja") return ja_save_completed_success(inputs)
	if (locale === "hi") return hi_save_completed_success(inputs)
	if (locale === "pt-PT") return pt_pt2_save_completed_success(inputs)
	return en_save_completed_success(inputs)
});